// PRICE_GROUP is an optional per-brand/hostname setting in public/config.js.
// Only forward it to the API when it's actually configured - endpoints fall
// back to the default price group on their own when the param is omitted.
export const getPriceGroupParam = () => {
    const ENV = window.ENV[window.location.hostname] || window.ENV.default;
    const priceGroup = ENV.PRICE_GROUP;
    return typeof priceGroup === 'string' && priceGroup.trim()
        ? { priceGroup: priceGroup.trim() }
        : {};
};
